import { Fragment } from 'react';
import PropTypes from 'prop-types';

import styles from './upload-file-components.module.scss';

export function UploadFileAttachments({ attachments }) {
  return (
    <div className={styles.attachments}>
      <h3>Attachments:</h3>
      <div className={styles.downloadLinks}>
        {attachments.map((attachment, i) => (
          <Fragment key={i}>{attachment}</Fragment>
        ))}
      </div>
    </div>
  );
}

UploadFileAttachments.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.node),
};
